import { useSelector } from 'src/store/react';
import { selectEnableZhForSSR } from 'src/store/selectors';

export const useEnableZhForSSR = () => useSelector(selectEnableZhForSSR);
